import { Address } from 'clerk_common/types/address';

export function formatAddressLine(
  addressOne?: string,
  addressTwo?: string,
  city?: string,
  state?: string,
  zip?: string,
  country?: string
): string {
  let text = '';
  if (addressOne) text += addressOne;
  if (addressTwo) text += needsSeparator(text) ? ` ${addressTwo}` : addressTwo;
  if (city) text += needsSeparator(text) ? `, ${city}` : city;
  if (state) text += needsSeparator(text) ? `, ${state}` : state;
  if (zip) text += needsSeparator(text) ? `${!state ? ',' : ''} ${zip}` : zip;
  if (country) text += needsSeparator(text) ? `, ${country}` : country;
  return text;
}

function needsSeparator(text: string) {
  return text.length > 0 && !text.endsWith(',');
}

export function formatAddress(address?: Address) {
  if (!address) return '';
  return formatAddressLine(
    address.addressOne,
    address.addressTwo,
    address.city,
    address.state,
    address.zip,
    address.country
  );
}

export function formatAddressLineOne(address?: Address) {
  if (!address) return '';
  return formatAddressLine(address.addressOne, address.addressTwo);
}

export function formatAddressLineTwo(address?: Address) {
  if (!address) return '';
  return formatAddressLine(
    undefined,
    undefined,
    address.city,
    address.state,
    address.zip,
    address.country
  );
}

const ADDRESS_TOKEN_ABBREVIATIONS: Record<string, string> = {
  AVENUE: 'AVE',
  BOULEVARD: 'BLVD',
  CIRCLE: 'CIR',
  COUNTY: 'CO',
  COURT: 'CT',
  DRIVE: 'DR',
  EAST: 'E',
  EXPRESSWAY: 'EXPY',
  FREEWAY: 'FWY',
  HIGHWAY: 'HWY',
  LANE: 'LN',
  NORTH: 'N',
  NORTHEAST: 'NE',
  NORTHWEST: 'NW',
  PARKWAY: 'PKWY',
  PLACE: 'PL',
  ROAD: 'RD',
  ROUTE: 'RT',
  RTE: 'RT',
  SOUTH: 'S',
  SOUTHEAST: 'SE',
  SOUTHWEST: 'SW',
  STREET: 'ST',
  SUITE: 'STE',
  TERRACE: 'TER',
  WEST: 'W',
};

function toFiveDigitZip(zip?: string) {
  const trimmed = zip?.trim();
  if (trimmed && /^\d{4}$/.test(trimmed)) return `0${trimmed}`;
  return trimmed?.match(/^(\d{5})-?\d{4}$/)?.[1] ?? trimmed;
}

function toComparisonTokens(text: string): string[] {
  return text
    .toUpperCase()
    .split(/[^A-Z0-9]+/)
    .filter(Boolean);
}

export function normalizeTextForComparison(text?: string): string {
  return toComparisonTokens(text ?? '').join(' ');
}

export function normalizeAddressForComparison(address: Address): string {
  return toComparisonTokens(
    [
      address.addressOne,
      address.addressTwo,
      address.city,
      address.state,
      toFiveDigitZip(address.zip),
    ].join(' ')
  )
    .map((token) => ADDRESS_TOKEN_ABBREVIATIONS[token] ?? token)
    .join(' ');
}

export function formatDataTableCellAddress(address?: Address | string) {
  if (!address || typeof address === 'string') return;
  return formatAddressLine('', '', address.city, address.state);
}
